/**
 * Vendor specific data for convenient reference of vendor-prefixed properties
 *
 * Example:
 * 	if(vendor.transition){
 * 		div.style[vendor.transition]=[vendor.transform,'1.0s','linear'].join(' ');
 * 		div.style[vendor.transform]=vendor.translate+(10px,0' + vendor.has3d? '0' : '')+')';
 * 	}
 */
define('Responsive/vendor',['require','exports','module'],function(require,exports,module){
    var tRANS = "trans",
        TRANS = "Trans",
        FORM  = "form",
        LATE  = "late",
        ITION = "ition",
        TOUCH = "touch",
        MOUSE = "mouse",
        undef;


    var reCamelCap=/^(\w)/ig,
        reCamelDash=/\-(\w)/ig,
    	reSupportPre=/has|^/,
    	agent=navigator.userAgent,
    	platform=navigator.platform,
        isAndroid=/Android\s/.test(agent),
    	root = document.documentElement,
    	klassPre='responsive-support-',
    	klass=root.className ? root.className.split(' ') : [],
    	tester = function(key){
    		return test.style[key]!== undef && key;
    	},
    	camelCaper=function($0,$1){
    		return $1.toUpperCase();
    	},
    	check = function(style){
        	var nodash=style.replace(reCamelDash,camelCaper);
        	return tester(nodash) || tester(id+(nodash.replace(reCamelCap,camelCaper))) || false;
        },
    	test=document.createElement('div'),
        id='webkit,Moz,O,ms'.replace(/([^,]+),?/g,function($0,$1){
            return tester($1+TRANS+FORM) ? $1 : '';
        }),
        camelid=({webkit : 'Webkit', Moz: '', O : 'O', ms: 'MS'})[id],
        camelPre=(camelid && camelid + 'T' || 't'),
        has3d= !!check('perspective'),
        css=['',id.toLowerCase(),''].join('-'),
        hasTransition=!!check(tRANS+ITION+'Property'),
        hasTouch = "ontouchstart" in window,
        androidV = (navigator.appVersion.match(/\s+(\d)+\.([\d\.]+)/)||[]),
        use3d    = has3d && (!isAndroid);

    var _vendor_={
            css         			: css,
            id          			: id,
            has3d       			: has3d,
            	// Our recommendation as to when you should use 3d translate
            use3d					: use3d,
            hasTransition			: hasTransition,
            idJS					: camelid,
            hasTouch				: hasTouch,
            isTouch     			: hasTouch,
            isAndroid				: isAndroid,
            isiOS					: /iP(\w+)\s/.test(agent),
            isMac					: /Mac/i.test(platform),
            isWp7 					: /msie\s/i.test(agent) || (/.NET/i).test(agent),
            hasInlineVideo			: !isAndroid,
            hasFixed				: (test.style.position="fixed") && test.style.position==="fixed" && (test.style.position="",true),
            hasFlex					: check('boxFlex') || check('flex'),
            transform   			: css+tRANS+FORM,
            transformJS   			: check(tRANS+FORM),
            transition  			: hasTransition ? css+tRANS+ITION : false,
            transitionJS  			: check(tRANS+ITION),
            	// Our recommendation as to when you should use native transitions
            useTransition  			: hasTransition && (use3d),
            transitionEvent       	: hasTransition ? (id==='Moz' ? tRANS : id+TRANS) + ITION+'End' : 'Re'+TRANS+ITION+'End',
            translate   			: tRANS+LATE + (use3d ? "3d" : ""),
            rotate	   			    : "rotate" + (use3d ? "3d" : ""),
            requestAnimationFrame 	: window[id + 'RequestAnimationFrame'] || window.requestAnimationFrame,
            cancelAnimationFrame 	: window[id + 'CancelAnimationFrame'] || window.cancelAnimationFrame,
            check					: check,

            eventMap 				: hasTouch ? {
            	CLICK		: "tap",  /* tap is non-standard convenience mapping for $ */
	            START       : TOUCH+"start",
	            MOVE        : TOUCH+"move",
	            END         : TOUCH+"end",
	            CANCEL      : TOUCH+"cancel"
	        } : {
	        	CLICK		: "click",
	            START       : MOUSE+"down",
	            MOVE        : MOUSE+"move",
	            END         : MOUSE+"up",
	            CANCEL      : MOUSE+"leave",
	        }
        };

        klass.push(klassPre+id);
        root.className=klass.join(' ')+('use3d,has3d,use'+TRANS+ITION+',has'+TRANS+ITION+',hasTouch,hasInlineVideo,hasFlex').replace(/(\w+)(?:,|$)/g,function($0,key){
        	return (' '+klassPre + key.replace(reSupportPre,!!_vendor_[key] ? '' : 'no-').toLowerCase());
        });
    return _vendor_;
});
